import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function NeedDocumentation() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      {" "}
      <legend>{t("Mobile number")}</legend>
      <input
        onChange={onChange}
        value={searchObject.mobileNumber || ""}
        name="mobileNumber"
        className="form-control"
      />
    </fieldset>
  );
}
